/*
  ヘッダーのハンバーガーメニューの動作と
  スクロール量に応じて色を変える処理です。

  普通に考えて、白地ベースでコーディングしなくちゃいけなかったんですが、
  透明時ベースで実装してしまいました。ごめんなさい。

  パ
*/

import 'intersection-observer';
import IntersectionObserver from 'intersection-observer-polyfill/dist/IntersectionObserver.js';
import buildThresholdsList from '../utils/buildThresholdsList';
import { gsap, TweenLite, CSSPlugin, Power2 } from 'gsap/all';

gsap.registerPlugin(CSSPlugin);

export default class Header {
  constructor() {
    this.header = document.querySelector('.l-header');
    this.firstview = document.querySelector('#firstview');
    this.pageTitle = document.querySelector('.l-page-title');
    this.menuTrigger = document.querySelector('.js-menu-trigger');
    this.menuBody = document.querySelector('.js-menu-body');
    this.menuItem = document.querySelectorAll('.js-menu-item');

    this.currentWidth = window.innerWidth;
    this.menuUsed = false;

    this.isShow = false;
    this.isAnimating = false;

    this.menuTrigger.addEventListener('click', event => {
      // 画面広げたときのリセット用
      this.menuUsed = true;
      if (!this.isShow) {
        this.openMenu(event.currentTarget);
        return;
      }
      this.closeMenu(event.currentTarget);
    });

    window.addEventListener('resize', () => {
      const updatedWidth = window.innerWidth;
      this.clearTweenProps(updatedWidth);
    });

    this.io = new IntersectionObserver(
      this.onIntersect.bind(this),
      {
        root: null,
        rootMargin: '0px 0px 0px 0px',
        threshold: buildThresholdsList(10)
      }
    )

    this.io.observe(this.firstview||this.pageTitle);

    //hover 背景色変更
    //マウスが要素上に入った時

    this.header.addEventListener('mouseover', event => {
      let body_id = document.body.getAttribute('id')
      let setResult = this.header.classList.contains('blue')
      switch(body_id) {
        case 'top':

          if( setResult !== true && window.innerWidth >= 768 ){
            this.header.classList.add('movie-blue');
          }else {return}

        break;
        default:
      }

    });
    //マウスが要素上から離れた時
    this.header.addEventListener('mouseleave', event => {
      this.header.classList.remove('movie-blue');

    });

  }

  onIntersect(entries) {
    if (entries[0].intersectionRatio <= 0) {
      this.header.classList.add('blue');
    }
    if (entries[0].intersectionRatio > 0) {
      this.header.classList.remove('blue');
    }
  }

  openMenu(button) {
    const self = this;
    if (this.isAnimating || this.isShow) return;
    this.isShow = true;
    this.isAnimating = true;
    this.header.classList.add('menu-active');
    button.classList.add('is-active');

    TweenLite.set(this.menuBody, { alpha: 0, display: 'none',
      onComplete() {
        TweenLite.to(this._targets[0], 0.7, { alpha: 1, display: 'block', ease: Power2.easeOut });
      }
    });

    TweenLite.to('.js-menu-item', 0, { opacity: 0, x: '+=30',
      onComplete() {
        TweenLite.to('.js-menu-item', 0.5, { opacity: 1, x: 0, ease: Power2.easeOut, stagger: 0.1, onComplete() { self.isAnimating = false; } });
      }
    });
  }

  closeMenu(button) {
    const self = this;
    if (this.isAnimating || !this.isShow) return;
    this.isAnimating = true;
    this.header.classList.remove('menu-active');
    button.classList.remove('is-active');

    TweenLite.to(this.menuBody, 0.7, { alpha: 0, display: 'none', ease: Power2.easeOut,
      onComplete() {
        self.isShow = false;
        self.isAnimating = false;
      }
    });
  }

  clearTweenProps(updatedWidth) {
    if (!this.menuUsed) return;
    // ハンバーガーメニューを操作済みで、
    // 幅変化前が1024より小さく、変化語が1024より大きい場合
    // clearTweenPropsでDOMについたStyleをクリアする
    if (this.currentWidth < 1024 && updatedWidth > this.currentWidth) {
      TweenLite.set(this.menuBody, { clearProps: 'all' });
    }
    this.currentWidth = updatedWidth;
  }
}
